import { motion } from "framer-motion";

export const easeQuart = [0.25, 1, 0.5, 1];

// Line-by-line masked reveal for hero headings
export function MaskedLines({ lines, className = "", delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-line">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, ease: easeQuart, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Scroll-triggered reveal
export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: easeQuart, delay }}
    >
      {children}
    </motion.div>
  );
}

// Overline label
export function Overline({ children, className = "" }) {
  return (
    <span className={`font-sans uppercase tracking-[0.24em] text-xs font-semibold text-brand-green ${className}`}>
      {children}
    </span>
  );
}
